import { create } from "zustand";

/**
 * Thin module-level store for the consumer notification bell badge.
 *
 * unreadCount: null = not yet fetched (badge hidden)
 * unreadCount: 0    = fetched, nothing not-read (badge hidden)
 * unreadCount: n    = n not-read (badge shows n)
 *
 * Badge semantics (pro parity):
 *   badge = count of NOT-read rows (read_state != 'read'), i.e. unread + seen.
 *   The bell badge and the per-row unread dot track the SAME population.
 *   Opening /feed calls MarkSeen (unread → seen) but the badge does NOT clear —
 *   it re-syncs to the authoritative not-read count and decrements only as the
 *   user actually reads items (tap / Mark-as-read). See FeedPage + the backend
 *   consumerinbox.Store.UnreadCount (COUNT WHERE read_state != 'read').
 */
interface NotificationsState {
  unreadCount: number | null;
  setUnreadCount: (count: number) => void;
}

export const useNotificationsStore = create<NotificationsState>((set) => ({
  unreadCount: null,
  setUnreadCount: (count) => set({ unreadCount: count }),
}));
